<template>
    <modal height="auto" width="90%" :scrollable="true" name="calendar-working-time" classes="modal_default" :clickToClose="true"  @before-open="beforeOpen">
    <div class="card" data-testid="calendar-working-time-dialog">
        <div class="card-header">
            Přehled pracovních termínů
        </div>
        <div class="card-body" v-if="workingTimePending">

        </div>
        <div class="card-body" v-else="">
            <div class="row" v-if="workingTime.length > 0">
                <table class="table">
                    <thead>
                    <tr class="row m-0">
                        <th class="col-sm-1">platné od</th>
                        <th class="col-sm-1">platné do</th>
                        <th class="col-sm-2">den / opakování</th>
                        <th class="col-sm-2">čas od - do</th>
                        <th class="col-sm-2">délka</th>
                        <th class="col-sm-1">pobočka</th>
                        <th class="col-sm-2">poznámka</th>
                        <th class="col-sm-1"></th>
                    </tr>
                    </thead>
                    <tbody>
                    <template v-for="wt in workingTime">
                        <tr class="row m-0 text-left" :data-testid="'calendar-working-time-row-' + wt.id">
                            <template v-if="editingId !== wt.id">
                              <td class="col-sm-1">{{ wt.valid_from }}</td>
                              <td class="col-sm-1">{{ wt.valid_to }}</td>
                              <td class="col-sm-2">{{ getDayNumToCS(wt.day) }} / {{ getWeeksRepeatCS(wt.odd_week, wt.even_week) }}</td>
                              <td class="col-sm-2">{{ wt.time_from }} - {{ wt.time_to }}</td>
                              <td class="col-sm-2">{{ wt.duration * 5 | minutesToCsTime }}</td>
                              <td class="col-sm-1">{{ wt.branch ? wt.branch.label : '' }}</td>
                              <td class="col-sm-2">{{ wt.note }}</td>
                            </template>

                            <td class="col-sm-11" v-else="">
                                <form @submit.prevent="submitFormUpdateWorkingTime">
                                    <div class="input-group">
                                        <span class="input-group-addon">platné od</span>
                                        <datepicker v-model="formWorkingTime.validFrom" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="chooseDate" input-class="datapickerInput" :disabled="disabledDateFrom"></datepicker>
                                        <span class="input-group-addon">do</span>
                                        <datepicker v-model="formWorkingTime.validTo" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="chooseDate" input-class="datapickerInput" :disabled="disabledDateTo"></datepicker>
                                        <span class="input-group-addon">den</span>
                                        <select v-model="formWorkingTime.day" class="form-control mr-sm-2" aria-describedby="doctorHelp" id="day" placeholder="vybrat den">
                                            <option v-for="n in 7" v-bind:value="n - 1">{{ getDayNumToCS(n - 1) }}</option>
                                        </select>
                                        <span class="input-group-addon">týden</span>
                                        <select v-model="formWorkingTime.repeating" class="form-control mr-sm-2" aria-describedby="doctorHelp" id="repeating" placeholder="vybrat týden">
                                            <option v-bind:value="0">lichý</option>
                                            <option v-bind:value="1">sudý</option>
                                            <option v-bind:value="2">každý</option>
                                        </select>
                                        <span class="input-group-addon">čas od</span>
                                        <timepicker :minute-interval="10" format="H:mm" v-model="formWorkingTime.timeFrom" disabled></timepicker>
                                        <span class="input-group-addon">do</span>
                                        <timepicker :minute-interval="10" format="H:mm" v-model="formWorkingTime.timeTo" disabled></timepicker>

                                        <span class="input-group-addon">pobočka</span>
                                        <select v-model="formWorkingTime.branchId" class="form-control mr-sm-2" aria-describedby="branchHelp" id="branch" placeholder="vybrat pobočku">
                                          <option value="" disabled selected>pobočka</option>
                                          <option v-for="row in branches" v-bind:value="row.id">{{ row.label }}</option>
                                        </select>

                                        <span class="input-group-addon">poznámka</span>
                                        <input v-model="formWorkingTime.note" type="text" class="form-control" id="workingTimeNote" placeholder="poznámka">
                                        <button v-if="updatedWorkingTimePending === false && possibleToSave === true" type="submit" class="btn btn-primary">Uložit</button>
                                        <button v-else-if="updatedWorkingTimePending === false" type="submit" class="btn btn-primary disabled" disabled="disabled">Uložit</button>
                                        <button class="btn btn-primary disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                                    </div>
                                </form>
                            </td>

                            <td class="col-sm-1 text-right">
                                <button class="btn btn-sm btn-danger" @click="deleteWorkingTime(wt.id)" v-if="editingId === false" :data-testid="'calendar-working-time-delete-' + wt.id"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                <button class="btn btn-sm btn-danger disabled" v-else="" disabled="disabled"><i class="fa fa-trash" aria-hidden="true"></i></button>
                                <button class="btn btn-sm btn-secondary" @click="setEditingWorkingTime(wt)" v-if="editingId === wt.id"><i class="fa fa-times" aria-hidden="true"></i></button>
                                <button class="btn btn-sm btn-secondary" @click="setEditingWorkingTime(wt)" v-else-if="editingId === false" :data-testid="'calendar-working-time-edit-' + wt.id"><i class="fa fa-edit" aria-hidden="true"></i></button>
                                <button class="btn btn-sm btn-secondary disabled" disabled="disabled" v-else=""><i class="fa fa-edit" aria-hidden="true"></i></button>
                            </td>
                        </tr>
                    </template>
                    </tbody>
                </table>
            </div>
            <div class="row" v-if="editingId === false">
                <div class="form-group col-md-12">
                    <form @submit.prevent="submitFormAddWorkingTime" data-testid="calendar-working-time-add-form">
                        <div class="input-group">
                            <span class="input-group-addon">platné od</span>
                            <datepicker v-model="formWorkingTime.validFrom" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="chooseDate" input-class="datapickerInput" :disabled="disabledDateFrom"></datepicker>
                            <span class="input-group-addon">do</span>
                            <datepicker v-model="formWorkingTime.validTo" placeholder="vybrat datum" format="dd.MM.yyyy" language="cs" :monday-first="true" :full-month-name="true" name="chooseDate" input-class="datapickerInput" :disabled="disabledDateTo"></datepicker>
                            <span class="input-group-addon">den</span>
                            <select v-model="formWorkingTime.day" class="form-control mr-sm-2" aria-describedby="doctorHelp" id="day" placeholder="vybrat den">
                                <option v-for="n in 7" v-bind:value="n - 1">{{ getDayNumToCS(n - 1) }}</option>
                            </select>
                            <span class="input-group-addon">týden</span>
                            <select v-model="formWorkingTime.repeating" class="form-control mr-sm-2" aria-describedby="doctorHelp" id="repeating" placeholder="vybrat týden">
                                <option v-bind:value="0">lichý</option>
                                <option v-bind:value="1">sudý</option>
                                <option v-bind:value="2">každý</option>
                            </select>
                            <span class="input-group-addon">čas od</span>
                            <timepicker :minute-interval="10" format="H:mm" v-model="formWorkingTime.timeFrom" disabled></timepicker>
                            <span class="input-group-addon">do</span>
                            <timepicker :minute-interval="10" format="H:mm" v-model="formWorkingTime.timeTo" disabled></timepicker>

                            <span class="input-group-addon">pobočka</span>
                              <select v-model="formWorkingTime.branchId" class="form-control mr-sm-2" aria-describedby="branchHelp" id="branch" placeholder="vybrat pobočku">
                                <option value="" disabled selected>pobočka</option>
                                <option v-for="row in branches" v-bind:value="row.id">{{ row.label }}</option>
                              </select>

                            <span class="input-group-addon">poznámka</span>
                            <input v-model="formWorkingTime.note" type="text" class="form-control" id="workingTimeNote" placeholder="poznámka" data-testid="calendar-working-time-note">
                            <button v-if="newWorkingTimePending === false && possibleToSave === true" type="submit" class="btn btn-success" data-testid="calendar-working-time-add">Přidat</button>
                            <button v-else-if="newWorkingTimePending === false" type="submit" class="btn btn-success disabled" disabled="disabled">Přidat</button>
                            <button class="btn btn-success disabled" disabled="disabled" v-else><i class="fa fa-spinner fa-pulse fa-fw"></i> Ukládám</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
    </modal>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        workingTime: null,
        workingTimePending: true,
        workingTimeError: false,
        newWorkingTime: {},
        newWorkingTimeError: false,
        newWorkingTimePending: false,
        newWorkingTimeDone: false,
        updatedWorkingTime: {},
        originalWorkingTime: {},
        formWorkingTime: {
          branchId: null,
          id: null,
          timeFrom: {
            H: '',
            mm: ''
          },
          timeTo: {
            H: '',
            mm: ''
          },
          validFrom: null,
          validTo: null,
          note: '',
          repeating: null
        },
        updatedWorkingTimeError: false,
        updatedWorkingTimePending: false,
        updatedWorkingTimeDone: false,
        deleteWorkingTimeError: false,
        deleteWorkingTimePending: false,
        deleteWorkingTimeDone: false,
        editingId: false,
        // branches
        branches: false,
        branchesPending: false,
        branchesError: false,
        //
        disabledDateFrom: {
          customPredictor (date) {
            // disables the date if it is a multiple of 5
            if (date.getDay() !== 1) {
              return true
            }
          }
        },
        disabledDateTo: {
          customPredictor (date) {
            // disables the date if it is a multiple of 5
            if (date.getDay() !== 0) {
              return true
            }
          }
        }
      }
    },
    props: ['opened', 'doctorId'],
    mixins: [apiMixin],
    methods: {
      beforeOpen () {
        this.getDoctorsWorkingTime(this.doctorId)
        this.getBranches()
      },
      setEditingWorkingTime (workingTime) {
        if (this.editingId === false) {
          this.formWorkingTime.validFrom = this.$moment(workingTime.valid_from, 'D.M.YYYY').toDate()
          this.formWorkingTime.validTo = this.$moment(workingTime.valid_to, 'D.M.YYYY').toDate()
          this.formWorkingTime.day = workingTime.day
          this.formWorkingTime.timeFrom.H = this.calculateHourFromWindow(workingTime.time_window) + ''
          this.formWorkingTime.timeFrom.mm = (this.calculateMinuteFromWindow(workingTime.time_window) + '').padStart(2, '0')
          this.formWorkingTime.timeTo.H = (this.calculateHourFromWindow(workingTime.time_window + workingTime.duration) % 24) + ''
          this.formWorkingTime.timeTo.mm = (this.calculateMinuteFromWindow(workingTime.time_window + workingTime.duration) + '').padStart(2, '0')
          this.formWorkingTime.note = workingTime.note
          this.formWorkingTime.branchId = workingTime.branch.id
          this.formWorkingTime.allDay = workingTime.all_day
          if (workingTime.odd_week === true && workingTime.even_week === true) {
            this.formWorkingTime.repeating = 2
          } else if (workingTime.odd_week === true) {
            this.formWorkingTime.repeating = 0
          } else {
            this.formWorkingTime.repeating = 1
          }
          this.editingId = workingTime.id
          this.originalWorkingTime = this.populateToSave(this.formWorkingTime)
        } else {
          this.formWorkingTime = {
            id: null,
            timeFrom: {
              H: '',
              mm: ''
            },
            timeTo: {
              H: '',
              mm: ''
            },
            validFrom: null,
            validTo: null,
            note: '',
            repeating: null,
            branchId: null
          }
          this.editingId = false
        }
      },
      calculateHourFromWindow (window) {
        return Math.floor((window - 1) / 12)
      },
      calculateMinuteFromWindow (window) {
        return ((window - 1) % 12) * 5
      },
      calculateWindowFromTime (hours, minutes) {
        return (((hours * 12) + (minutes / 5)) + 1)
      },
      calculateWindowDurationFromTime (hoursFrom, minutesFrom, hoursTo, minutesTo) {
        // Use 0:00 like 24:00
        if ((hoursTo + '' + minutesTo) === '000') {
          hoursTo = 24
        }
        return (this.calculateWindowFromTime(hoursTo, minutesTo) - this.calculateWindowFromTime(hoursFrom, minutesFrom))
      },
      isTimeFilled: function (from, to) {
        return (from.H !== '' && from.mm !== '' && to.H !== '' && to.mm !== '')
      },
      isDurationPositive (from, to) {
        return (this.calculateWindowDurationFromTime(from.H, from.mm, to.H, to.mm) > 0)
      },
      tryPopulateFromForm () {
        if (this.possibleToSave === true) {
          if (this.editingId !== false) {
            this.updatedWorkingTime = this.populateToSave(this.formWorkingTime)
          } else {
            this.newWorkingTime = this.populateToSave(this.formWorkingTime)
            delete this.newWorkingTime.id
          }
        } else {
          this.updatedWorkingTime = {}
        }
      },
      populateToSave (formData) {
        let saveData = {}
        saveData.time_window = this.calculateWindowFromTime(formData.timeFrom.H, formData.timeFrom.mm)
        saveData.duration = this.calculateWindowDurationFromTime(formData.timeFrom.H, formData.timeFrom.mm, formData.timeTo.H, formData.timeTo.mm)
        saveData.id = this.editingId
        saveData.valid_from = this.$moment(formData.validFrom).format('L')
        saveData.valid_to = this.$moment(formData.validTo).format('L')
        saveData.branch_id = formData.branchId

        if (formData.repeating === 0) {
          saveData.odd_week = true
          saveData.even_week = false
        } else if (formData.repeating === 1) {
          saveData.odd_week = false
          saveData.even_week = true
        } else {
          saveData.odd_week = true
          saveData.even_week = true
        }
        saveData.note = formData.note
        saveData.day = formData.day
        return saveData
      },
      submitFormUpdateWorkingTime () {
        this.putWorkingTime(this.updatedWorkingTime)
      },
      submitFormAddWorkingTime () {
        this.postWorkingTime(this.newWorkingTime, this.doctorId)
      },
      getDayNumToCS (num) {
        return this.$moment().day(num + 1).format('dddd')
      },
      getWeeksRepeatCS (odd, even) {
        if (odd === true && even === true) {
          return 'každý týden'
        } else if (odd === true) {
          return 'lichý týden'
        } else if (even === true) {
          return 'sudý týden'
        } else {
          return 'žádný týden'
        }
      }
    },
    watch: {
      'formWorkingTime.timeFrom' () {
        this.tryPopulateFromForm()
      },
      'formWorkingTime.timeTo' () {
        this.tryPopulateFromForm()
      },
      'formWorkingTime.validFrom' () {
        this.tryPopulateFromForm()
      },
      'formWorkingTime.validTo' () {
        this.tryPopulateFromForm()
      },
      'formWorkingTime.day' () {
        this.tryPopulateFromForm()
      },
      'formWorkingTime.note' () {
        this.tryPopulateFromForm()
      },
      'formWorkingTime.branchId' () {
        this.tryPopulateFromForm()
      },
      'formWorkingTime.repeating' () {
        this.tryPopulateFromForm()
      },
      newWorkingTimeDone (val) {
        this.newWorkingTime = {}
        if (val === true) {
          this.getDoctorsWorkingTime(this.doctorId)
          this.newWorkingTimeDone = false
        }
      },
      deleteWorkingTimeDone (val) {
        if (val === true) {
          this.getDoctorsWorkingTime(this.doctorId)
          this.deleteWorkingTimeDone = false
        }
      },
      updatedWorkingTimeDone (val) {
        if (val === true) {
          this.$emit('working-time-updated')
          this.editingId = false
          this.updatedWorkingTime = {}
          this.getDoctorsWorkingTime(this.doctorId)
          this.updatedWorkingTimeDone = false
        }
      },
      branchesPending (val) {
        if (val === false) {
          for (let i = 0; i < this.branches.length; i++) {
            if (this.branches[i].default === true) {
              this.formWorkingTime.branchId = this.branches[i].id
            }
          }
        }
      }
    },
    computed: {
      possibleToSave: function () {
        return ((this.isDurationPositive(this.formWorkingTime.timeFrom, this.formWorkingTime.timeTo) && this.isTimeFilled(this.formWorkingTime.timeFrom, this.formWorkingTime.timeTo)) || this.formWorkingTime.allDay === true)
      },
      formChanged: function () {
        return JSON.stringify(this.originalWorkingTime) !== JSON.stringify(this.updatedWorkingTime)
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Calendar/modals/WorkingTime.vue?594b3254